import createChangeCartItemsThunk from '../helpers/createChangeCartItemsThunk';
import updateQuantity from '../content/changesets/updateQuantity';

export default createChangeCartItemsThunk(
  'session/updateCartItemQuantity',
  updateQuantity,
);
